export interface Report {
  id: string;
  app: string;
  userEmail: string;
  description: string;
  timestamp: string;
  level: SeverityLevel;
  imageUrl1: string | null;
  imageUrl2: string | null;
  imageUrl3: string | null;
  videoUrl: string | null;
}

export enum SeverityLevel {
  Low = "low",
  Medium = "medium",
  High = "high",
  Critical = "critical",
}

export const SEVERITY_LEVELS = Object.values(SeverityLevel);

export const REPORT_APPS = [
  "Expense Tracker",
  "One-Time Upload",
  "Football Teams Organizer",
  "Configurable Web Scraper",
  "JOIP",
  "Restaurant Logger",
  "Secure Image Storage",
  "Membership Manager",
  "Limited Time Services",
  "Analytics",
  "Feature Flags",
  "News Portal",
  "Alliances",
  "Portals",
  "Timeify",
] as const;
